import React, { Component } from "react"
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import Axios from "axios"
import load from '../assets/loading.gif'
import { BASE } from "../api/api"
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom'
import { getName } from 'country-list'
import cachios from 'cachios';

class Approve extends Component {
    constructor(props) {
        super(props)
        this.state = {
            load: false,
            included: '',
            nids: [],
            refer: [],
            journal: [],
            inst: [],
            descr: [],
            authors: [],
            affl: [],
            booktitle: [],
            publisher: [],
            related: [],
            conf: [],
            pdf: [],
            journal_img: [],
            loader: true,
            articletype: '',
            booktype: '',
            chaptype: '',
            conftype: '',
            thesistype: '',
        }
    }
    inst(nid, title) {
        return '/taxonomy/' + title + '/' + nid
    }
    checkapprove() {
        this.setState({
            load: true
        })

        const body = {
            "user_id": this.props.match.params.id,
            "authorname": this.props.match.params.name,
            "publication_id": this.props.match.params.pubid
        }
        Axios.post(`${BASE}customapi/approvepublication`, body)
            .then(data => {
                this.setState({ load: false })
                alert("Approved Successfully")
                this.props.history.push("/")
            })
            .catch(err => {
                this.setState({ load: false })
                console.log("Error on approving", err)
                alert("Error on approving")
            })
    }
    checkreject() {
        this.setState({
            load: true
        })
        const body = {
            "user_id": this.props.match.params.id,
            "authorname": this.props.match.params.name,
            "publication_id": this.props.match.params.pubid
        }
        Axios.post(`${BASE}customapi/rejectpublication`, body)
            .then(data => {
                this.setState({ load: false })
                alert("Rejected Successfully")
                this.props.history.push("/")

            })
            .catch(err => {
                this.setState({ load: false })
                console.log("Error on rejecting", err)
                alert("Error on approving")
            })
    }
    componentDidMount() {
        console.log('approve info', this.props.match.params.name, this.props.match.params.id, this.props.match.params.pubid)
        this.getWork(this.props.match.params.pubid)
    }
    journlink(nid, title, type) {
        return '/content/' + title + '/' + type + '/' + nid
    }
    getWork(id) {
        Axios.get(`${BASE}jsonapi/node/submit_for_work?include=field_select_work_to_submit,field_image,field_conference,field_publisher,field_affliations,field_author,field_references,field_descriptors,field_full_text_pdf,field_institution,field_journal,field_journal.field_image,field_books.field_image&filter[drupal_internal__nid]=${id}`)
            .then(data => {
                if (data.data.data.length) {
                    console.log('approve work', data.data.data[0])
                    this.setState({
                        publication_type: data.data.included.filter(item => item.type === "taxonomy_term--submit_for_work_types")[0].attributes.name,
                        sub_data: data.data.data[0].attributes,
                        loader: false,
                        book_name: data.data.data[0].relationships.field_books.data,
                        reflength: data.data.data[0].relationships.field_references.data.length,
                        included_data: data.data.included
                    })
                    {
                        data.data.included ? data.data.included.map((include, index) => {
                            if (include.type === "node--submit_for_work") {
                                let refer = this.state.refer
                                if (include.relationships.field_image.data) {
                                    let journal_img = BASE + data.data.included.filter(item => item.id === include.relationships.field_image.data.id)[0].attributes.uri.url
                                    let journal_img_array = this.state.journal_img
                                    journal_img_array.push(journal_img)
                                    this.setState({
                                        journal_img: journal_img_array
                                    })
                                }
                                console.log(include, 'xxxzzz')
                                if (this.state.related.length === 0) {
                                    let related = this.state.related
                                    this.getauthor(include.id)
                                    related.push(include)
                                    console.log("related", include)
                                    this.setState({
                                        related: related

                                    })
                                    console.log(nids, 'xxxxx')



                                }
                                let nids = this.state.nids
                                nids.push(include.attributes.drupal_internal__nid)
                                refer.push(include)
                                this.setState({
                                    refer: refer,
                                    nids: nids
                                })
                                if (this.state.nids.length === this.state.reflength) {
                                    let i, filter = []
                                    for (i = 0; i < nids.length; i++) {
                                        filter.push('f[' + i + ']=nid:' + nids[i])
                                    }
                                    console.log(nids, 'xxxxx')
                                    console.log(BASE + 'api/search?Keyword=*&from=0&size=100&' + filter.join('&'), 'xxxxx')
                                    if (filter.length === nids.length)
                                        cachios.get(BASE + 'api/search?Keyword=*&from=0&size=100&' + filter.join('&'), {
                                            ttl: 500 /* seconds */,
                                        })
                                            .then((data) => {
                                                console.log(data, 'xxxxx')
                                                this.setState({
                                                    refernew: data.data.hits.hits
                                                })

                                                // this.setState({
                                                //     sub_data: data.data.data[0].attributes,
                                                //     loader: false,
                                                //     reflength:data.data.data[0].relationships.field_references.data.length
                                                // })
                                            })
                                }
                                if (this.state.scroll)
                                    this.scroll()
                            }
                            else if (include.type === "node--journals") {
                                let journal = this.state.journal
                                journal.push(include)
                                this.setState({
                                    journal: journal
                                })
                                if (include.relationships.field_image.data) {
                                    let journal_img = BASE + data.data.included.filter(item => item.id === include.relationships.field_image.data.id)[0].attributes.uri.url
                                    let journal_img_array = this.state.journal_img
                                    journal_img_array.push(journal_img)
                                    this.setState({
                                        journal_img: journal_img_array
                                    })
                                }
                                if (this.state.scroll)
                                    this.scroll()
                            }
                            else if (include.type === "node--biographies") {
                                let authors = this.state.authors
                                authors.push(include)
                                this.setState({
                                    authors: authors
                                })
                                if (this.state.scroll)
                                    this.scroll()
                            }
                            else if (include.type === "file--image") {
                                console.log(data.data.data[0].relationships, "jounaldata")
                                if (data.data.data[0].relationships.field_journal.data) {
                                    console.log("imgdata", include)
                                    if (data.data.included.filter(item => item.type === "node--journals")[0].relationships.field_image.data) {
                                        if (include.id === data.data.included.filter(item => item.type === "node--journals")[0].relationships.field_image.data.id) {
                                            let journal_img = BASE + data.data.included.filter(item => item.id === include.relationships.field_image.data.id)[0].attributes.uri.url
                                            let journal_img_array = this.state.journal_img
                                            journal_img_array.push(journal_img)
                                            this.setState({
                                                journal_img: journal_img_array
                                            })
                                        }
                                        else {
                                            this.setState({
                                                img: BASE + include.attributes.uri.url
                                            })
                                        }
                                    }
                                    else {
                                        this.setState({
                                            img: BASE + include.attributes.uri.url
                                        })
                                    }
                                }
                                else {
                                    this.setState({
                                        img: BASE + include.attributes.uri.url
                                    })
                                }

                                if (this.state.scroll)
                                    this.scroll()
                            }
                            else if (include.type === "node--conference") {
                                let conf = this.state.conf
                                conf.push(include)
                                this.setState({
                                    conf: conf
                                })
                                if (this.state.scroll)
                                    this.scroll()
                            }
                            else if (include.type === "taxonomy_term--university_college") {
                                let inst = this.state.inst
                                inst.push(include)
                                console.log(include, "inst123")
                                this.setState({
                                    inst: inst
                                })
                                if (this.state.scroll)
                                    this.scroll()
                            }
                            else if (include.type === "taxonomy_term--descriptors") {
                                let descr = this.state.descr
                                descr.push(include)
                                this.setState({
                                    descr: descr
                                })
                                if (this.state.scroll)
                                    this.scroll()
                            }
                            else if (include.type === "taxonomy_term--affiliations") {
                                let affl = this.state.affl
                                affl.push(include)
                                this.setState({
                                    affl: affl
                                })
                                if (this.state.scroll)
                                    this.scroll()
                            }

                            else if (include.type === "taxonomy_term--publisher") {
                                let publisher = this.state.publisher
                                publisher.push(include)
                                console.log("pubb", publisher)
                                this.setState({
                                    publisher: publisher
                                })
                                if (this.state.scroll)
                                    this.scroll()
                            }
                            else if (include.type === "file--document") {
                                console.log("pdff", include.attributes.uri.url)
                                let item = include.attributes.uri.url
                                let arr = this.state.pdf
                                let pdfname = this.state.pdfname ? this.state.pdfname : []
                                if (arr.indexOf(item) === -1) {
                                    arr.push(BASE + item);
                                    pdfname.push(include.attributes.filename)
                                }
                                this.setState({
                                    pdf: arr,
                                    pdfname: pdfname
                                })
                                if (this.state.scroll)
                                    this.scroll()
                            }
                        })


                            : this.setState({
                                refer: [],
                                journal: [],
                                inst: [],
                                descr: [],
                                authors: [],
                                affl: []

                            })
                    }

                }
                else {
                    alert("Publication not found")
                }
            })
    }
    render() {
        return (
            <div className="successpage approve-reject">
                {this.state.load ? <div className='loading'>
                    <img src={load} alt='load' />
                </div> : ''}
                <Header />
                <div className="listing" >
                    <div className="main-content">
                        <div className="container">
                            <div className='head'>
                                Accept or Reject Co-author Invite
                            </div>
                            {this.state.sub_data ? <div className="work-details">
                                <div className="title">{this.state.sub_data.title ? this.state.sub_data.title : ""}</div>
                                <div className="field-item even" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative' }}>
                                    <div className="view-wiki">
                                        {this.state.sub_data ?
                                            <ul>
                                                {this.state.authors.length != 0 ?
                                                    <li className="first" style={{ display: 'flex', flexDirection: 'row', marginBottom: '0', paddingBottom: '0' }}>

                                                        <div className="field-name-field-body author-field">
                                                            {this.state.authors.map((include, index) => {
                                                                return (
                                                                    <div className='references author-name'>
                                                                        {ReactHtmlParser(include.attributes.title)}{this.state.authors.length - 1 !== index ? ';' : ''}
                                                                    </div>
                                                                )
                                                            })
                                                            }
                                                        </div>
                                                    </li> : ''}

                                                {this.state.affl ?
                                                    <li className="first" style={{ display: 'flex', flexDirection: 'row', marginTop: '0', paddingTop: '0' }}>
                                                        <div className="field-name-field-body author-field">
                                                            <div className='references author-name'>
                                                                {this.state.affl.attributes ? ReactHtmlParser(this.state.affl.attributes.name) : ''}
                                                            </div>
                                                        </div>
                                                    </li> : ''}
                                                {this.state.publication_type ?
                                                    this.state.publication_type === "Articles" ?
                                                        <div style={{
                                                            alignItems: 'center', display: "contents"
                                                        }}>
                                                            {this.state.journal.length !== 0 ?
                                                                this.state.journal.map((include, index) => {
                                                                    return (
                                                                        ReactHtmlParser(include.attributes.title)
                                                                    )
                                                                })

                                                                : ''}
                                                            {this.state.affl.map((include, index) => {
                                                                return (
                                                                    <span className='references author-name'>
                                                                        <Link to={include.attributes.drupal_internal__tid, include.attributes.name.replace(/\//g, "-")}> ,{ReactHtmlParser(include.attributes.name)}</Link>
                                                                        {this.state.affl.length - 1 !== index ? ' ' : ''}
                                                                    </span>
                                                                )
                                                            })
                                                            }
                                                            {this.state.sub_data.field_volume ? ', ' + this.state.sub_data.field_volume : ''}{this.state.sub_data.field_number ? '(' + this.state.sub_data.field_number + ')' : ''}{this.state.sub_data.field_year ? ', ' + this.state.sub_data.field_year : ''}{this.state.sub_data.field_pages ? ', ' + this.state.sub_data.field_pages : ''}
                                                        </div>
                                                        : ''
                                                    : ''}
                                                {this.state.publication_type ?
                                                    this.state.publication_type === "Books" ?
                                                        <div style={{
                                                            alignItems: 'center', display: "contents"
                                                        }}>
                                                            {this.state.sub_data.field_place ? this.state.sub_data.field_place + ':' : ''}{this.state.publisher ?

                                                                this.state.publisher.attributes ? ReactHtmlParser(this.state.publisher.attributes.name)

                                                                    : '' : ""}{this.state.sub_data.field_year ? ', ' + this.state.sub_data.field_year : ''}{this.state.sub_data.field_pages && this.state.sub_data.field_pages !== 'N/A' ? ', ' + this.state.sub_data.field_pages : ''}{this.state.sub_data.field_isbn && this.state.sub_data.field_isbn != 'N/A' ? ', ' + this.state.sub_data.field_isbn : ''}
                                                            { }
                                                        </div>
                                                        : ''
                                                    : ''}

                                                {this.state.publication_type ?
                                                    this.state.publication_type === "Book Chapters" ?
                                                        <div style={{
                                                            alignItems: 'center', display: "contents"
                                                        }}>
                                                            {this.state.relauthor ? this.state.relauthor.length !== 0 ?
                                                                this.state.relauthor.map((rel, index) => {
                                                                    return (
                                                                        rel.title + '; '
                                                                    )
                                                                })
                                                                : '' : ''}
                                                            {this.state.related.length ?
                                                                this.state.related.map((include, index) => {
                                                                    if (index === 0)
                                                                        return (
                                                                            include.attributes.title + ', '
                                                                        )
                                                                })
                                                                : ''}

                                                            {this.state.sub_data.field_place ? this.state.sub_data.field_place + ': ' : ''}
                                                            {this.state.publisher.length ?
                                                                this.state.publisher.map((include, index) => {
                                                                    return (
                                                                        ReactHtmlParser(include.attributes.name)
                                                                    )
                                                                }) : ''}{this.state.sub_data.field_year ? ', ' + this.state.sub_data.field_year : ''}{this.state.sub_data.field_pages ? ', ' + this.state.sub_data.field_pages : ''}{this.state.sub_data.field_isbn && this.state.sub_data.field_isbn != "N/A" ? ', ' + this.state.sub_data.field_isbn : ""}
                                                        </div>
                                                        : ''
                                                    : ''}

                                                {this.state.publication_type ? this.state.publication_type === "Conferences" ?
                                                    <div style={{
                                                        alignItems: 'center', display: "contents"
                                                    }}>
                                                        {this.state.affl.length != 0 ?
                                                            this.state.affl.map((include, index) => {
                                                                return (
                                                                    ReactHtmlParser(include.attributes.name) + this.state.affl.length - 1 !== index ? ' ' : ''
                                                                )
                                                            })
                                                            : ''}

                                                        {this.state.conf.length != 0 ?
                                                            this.state.conf.map((include, index) => {
                                                                return (
                                                                    this.state.queryobj.search === "true" ?
                                                                        ReactHtmlParser(include.attributes.title) :
                                                                        ReactHtmlParser(include.attributes.title)
                                                                )
                                                            })

                                                            : ''}
                                                        {this.state.conf.length != 0 ? this.state.conf[0].attributes.field_city ? ', ' + this.state.conf[0].attributes.field_city : '' : ''}{this.state.sub_data.field_country ? ' - ' + ReactHtmlParser(getName(this.state.sub_data.field_country)) : ""}

                                                        {this.state.sub_data.field_year ? ', ' + this.state.sub_data.field_year : ''}
                                                    </div> : '' : ''
                                                }

                                                {this.state.publication_type ? this.state.publication_type === "Thesis" ?
                                                    <div style={{
                                                        alignItems: 'center', display: "contents"
                                                    }}>
                                                        {this.state.inst.map((include, index) => {
                                                            return (
                                                                ReactHtmlParser(include.attributes.name)
                                                            )
                                                        })
                                                        }{this.state.sub_data ? this.state.sub_data.field_degree ? this.state.sub_data.field_degree !== 'N/A' ?
                                                            ', ' + this.state.sub_data.field_degree.replace(/\.+$/, "")
                                                            : '' : '' : ''}{this.state.sub_data.field_year ? ', ' + this.state.sub_data.field_year : ''}{this.state.sub_data.field_pages ? ', ' + this.state.sub_data.field_pages : ''}
                                                    </div>
                                                    : '' : ''}
                                            </ul> : ''}
                                    </div>
                                </div>
                                <p className="body">{this.state.sub_data.body ? ReactHtmlParser(this.state.sub_data.body.value) : ""}</p>
                            </div> : ""}
                            <p className="verify-info">
                                If you are willing to be added as the co author of the above work,
                            </p>
                            <p className="verify-info">
                                please click on accept else reject.
                            </p>
                            <div className="approve-row">
                                <div className='pointer approvebtn' onClick={() => this.checkapprove()}>
                                    Approve
                                </div>
                                <div className='pointer rejectbtn' onClick={() => this.checkreject()}>
                                    Reject
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export default Approve;